import React from "react";
import { useHistory } from "react-router-dom";
import {  useDispatch } from "react-redux";
import { PATHS } from "util/appConstants";
import Navbar from "components/Navbar";
import LightLayout from "components/Shared/LightLayout";
import RoleForm from "components/Roles/form";
import { addRole } from "redux/slices/rolesSlice";

const currentAction = "ADD";
const AddRole = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const onSubmit = async (payload) => {
    await dispatch(addRole(payload)).then((res) =>
      res !== undefined ? history.push(PATHS.admin.roles) : ""
    );
  };

  return (
    <>
      <Navbar />
      <LightLayout doublebar>
        <RoleForm action={currentAction} onSubmit={onSubmit}/>
      </LightLayout>
    </>
  );
};

export default AddRole;
